// export const dicionaryInput = ["required", "length"]
export const validateInput = (rule, value) => {
    switch (rule.type) {
    case 'email':
        return emailValidate(rule, value);
    case 'number':
        return numberValidate(rule, value);
    case 'money':
        return moneyValidate(rule, value);
    case 'password':
        return passwordValidate(rule, value);
    case 'text':
        return textValidate(rule, value);
    case 'cnpj':
        return CNPJValidate(rule, value);
    case 'cpf':
        return CPFValidate(rule, value);
    }
};
export const emailValidate = (rule, value) => {
    if (rule.required) {
        if (value.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    }
    const user = value.substring(0, value.indexOf('@'));
    const domain = value.substring(value.indexOf('@') + 1, value.length);
    // essse algoritomo valida se o email é valido, por isso, estamos negando a equação,
    // precisamos saber se o email é inválido
    if (
        !(
            user.length >= 1 &&
            domain.length >= 3 &&
            user.search('@') == -1 &&
            domain.search('@') == -1 &&
            user.search(' ') == -1 &&
            domain.search(' ') == -1 &&
            domain.search('.') != -1 &&
            domain.indexOf('.') >= 1 &&
            domain.lastIndexOf('.') < domain.length - 1
        )
    ) {
        return `Insira um ${rule.name} válido.`;
    }

    return '';
};
export const passwordValidate = (rule, value) => {
    if (rule.required) {
        if (value.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    }
    if (rule.length) {
        if (rule.length > value.split('').length) {
            return `Por favor, forneça ao menos ${rule.length} caracteres.`;
        }
    }
    return '';
};
export const textValidate = (rule, value) => {
    if (value == undefined) {
        return `O campo ${rule.name} é obrigatório.`;
    }
    if (rule.required) {
        if (value.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    }
    if (value.trim('').split('').length > 0 && rule.length) {
        if (rule.length > value.split('').length) {
            return `Por favor, forneça ao menos ${rule.length} caracteres.`;
        }
    }
    if (value.trim('').split('').length > 0 && rule.lengthMax) {
        if (rule.lengthMax < value.split('').length) {
            return `Por favor, forneça até ${rule.lengthMax} caracteres.`;
        }
    }
    return '';
};
export const numberValidate = (rule, value) => {
    if (value == undefined) {
        return `O campo ${rule.name} é obrigatório.`;
    }
    if (isNaN(parseFloat(value))) {
        return 'Por favor, forneça apenas numeros';
    }
    if (rule.required) {
        if (value.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    }
    if (value.trim('').split('').length > 0 && rule.positive) {
        if (parseFloat(value) < 0) {
            return 'Por favor, forneça numeros positivos';
        }
    }
    return '';
};

export const moneyValidate = (rule, value) => {
    if (value == undefined) {
        return `O campo ${rule.name} é obrigatório.`;
    }
    if (isNaN(parseFloat(value.replace(',', '.')))) {
        return 'Por favor, forneça apenas numeros';
    }
    if (rule.required) {
        if (parseFloat(value.replace(',', '.')) === 0.0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    }
    if (rule.positive) {
        if (parseFloat(value.replace(',', '.')) < 0) {
            return 'Por favor, forneça numeros positivos';
        }
    }
    return '';
};

export const CNPJValidate = (rule, cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (rule.required) {
        if (cnpj.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    } else {
        if (cnpj.trim('').split('').length == 0) {
            return '';
        }
    }
    if (cnpj.length != 14) {
        return 'Por favor, forneça ao menos 14 caracteres.';
    }

    // Elimina CNPJs invalidos conhecidos
    if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
    ) {
        return `O campo ${rule.name} não é válido.`;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) {
        return `O campo ${rule.name} não é válido.`;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) {
        return `O campo ${rule.name} não é válido.`;
    }

    return '';
};
export const CPFValidate = (rule, value) => {
    let isValidCpf = true;

    if (rule.required) {
        if (value.trim('').split('').length == 0) {
            return `O campo ${rule.name} é obrigatório.`;
        }
    } else {
        if (value.trim('').split('').length == 0) {
            return '';
        }
    }
    // this is mostly not needed
    const invalidos = [
        '111.111.111-11',
        '222.222.222-22',
        '333.333.333-33',
        '444.444.444-44',
        '555.555.555-55',
        '666.666.666-66',
        '777.777.777-77',
        '888.888.888-88',
        '999.999.999-99',
        '000.000.000-00',
    ];

    for (let i = 0; i < invalidos.length; i++) {
        if (invalidos[i] == value) {
            isValidCpf = false;
        }
    }

    value = value.replace('-', '');
    value = value.replace(/\./g, '');

    // validando primeiro digito
    let add = 0;
    for (let i = 0; i < 9; i++) {
        add += parseInt(value.charAt(i), 10) * (10 - i);
    }
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(value.charAt(9), 10)) {
        isValidCpf = false;
    }

    // validando segundo digito
    add = 0;
    for (let i = 0; i < 10; i++) {
        add += parseInt(value.charAt(i), 10) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(value.charAt(10), 10)) {
        isValidCpf = false;
    }

    return isValidCpf ? '' : 'CPF não é válido';
};
